export const QuantityStateEnum = {
  Available: 0,
  AvailableWithLiveShopping: 1,
  AvailableDealOnly: 2,
  AvailableRegularOnly: 3,
  Unavailable: 4,
};
